<template>
  <vx-card class="sale-invoice mx-auto main-box top-zero-radius">

    <vs-row class="general-fields">
      <vs-col class="sm:pr-2 md:w-1/4 sm:w-1/2">
        <custom-number-input :label="$t('sales.invoices.labels.id')"
                             :placeholder="$t('sales.invoices.placeholder.id')"
                             :is-empty="true"
                             :styles="{width: '100%'}"
                             :disabled="true"
                             v-model="invoice.id"/>
      </vs-col>

      <vs-col class="sm:pr-2 md:w-1/4 sm:w-1/2">
        <custom-validate-input :label="$t('sales.invoices.labels.status')"
                               :class="invoice.status.id === 2 ? 'danger' : ''"
                               :styles="{width: '100%'}"
                               :disabled="true"
                               :is-empty="true"
                               v-model="invoice.status"/>
      </vs-col>

      <vs-col class="sm:pr-2 md:w-1/4 sm:w-1/2">
        <custom-validate-input :label="$t('sales.invoices.labels.actionType')"
                               :styles="{width: '100%'}"
                               :disabled="true"
                               :is-empty="true"
                               v-model="invoice.actionType"/>
      </vs-col>

      <vs-col class="md:w-1/4 sm:w-1/2">
        <custom-validate-input :label="$t('sales.invoices.labels.date')"
                               :styles="{width: '100%'}"
                               :disabled="true"
                               :is-empty="true"
                               v-model="invoice.date"/>
      </vs-col>
    </vs-row>

    <vs-row>
      <vs-col class="">
        <div class="owner-info user">
          <span class="title">{{ $t('sales.invoices.labels.userInfo') }}</span>

          <div @click="imageUserPreviewStatus = true"
               class="user-image">
            <lazy-image class="profile-avatar cursor-pointer"
                        :src="invoice.user.avatar"
                        :alt="invoice.user.name"/>
          </div>

          <image-preview v-if="imageUserPreviewStatus"
                         :image="{src: invoice.user.avatar, alt: invoice.user.name}"
                         @closed="imageUserPreviewStatus = false"/>

          <div class="user-info">
            <template v-for="(userInfo, key) in getAsiderUserProfileInfo">
              <div class="user-info-item" :key="key">
                <span class="pre-content">{{ userInfo.label }}</span>
                <span class="content">{{ userInfo.content }}</span>
              </div>
            </template>
          </div>
        </div>
      </vs-col>
    </vs-row>

    <vs-row v-if="invoice.coach.id > 0">
      <vs-col class="">
        <div class="coach-info user">
          <span class="title">{{ $t('sales.invoices.labels.coachInfo') }}</span>

          <div @click="imageCoachPreviewStatus = true"
               class="user-image">
            <lazy-image class="profile-avatar cursor-pointer"
                        :src="invoice.coach.avatar"
                        :alt="invoice.coach.name"/>
          </div>

          <image-preview v-if="imageCoachPreviewStatus"
                         :image="{src: invoice.coach.avatar, alt: invoice.coach.name}"
                         @closed="imageCoachPreviewStatus = false"/>

          <div class="user-info">
            <template v-for="(userInfo, key) in getAsiderCoachProfileInfo">
              <div class="user-info-item" :key="key">
                <span class="pre-content">{{ userInfo.label }}</span>
                <span class="content">{{ userInfo.content }}</span>
              </div>
            </template>
          </div>
        </div>
      </vs-col>
    </vs-row>


    <div class="products-fields">
      <draggable-dynamic-table v-if="invoice.lines.length"
                               :in-modal="true"
                               :active-grid="true"
                               :fix-screen="true"
                               :options="options"
                               :columns="columnsLabel"
                               :data="invoice.lines"/>
    </div>
    <div class="price-box">
      <div class="price-details">
        <div class="price-details-row">
          <div class="price-details-title">
            <b>{{ $t('sales.invoices.labels.totalPrice') }}</b>
          </div>

          <div class="price-details-price">
            <span>{{ addComma(parseInt(invoice.totalPrice.value)) || 0 }}</span>
            <span>{{ $t('currency') }}</span>
          </div>
        </div>

        <div class="price-details-row">
          <div class="price-details-title">
            <b>{{ $t('sales.invoices.labels.discount') }}</b>
          </div>

          <div class="price-details-price">
            <span>{{ addComma(parseInt(invoice.discount.value)) || 0 }}</span>
            <span>{{ $t('currency') }}</span>
          </div>
        </div>

        <div v-if="invoice.status.id === 2" class="price-details-row">
          <div class="price-details-title">
            <b>{{ $t('sales.invoices.labels.reject') }}</b>
          </div>

          <div class="price-details-price">
            <span>{{ addComma(parseInt(invoice.cancelPrice.value)) || 0 }}</span>
            <span>{{ $t('currency') }}</span>
          </div>
        </div>

        <div class="price-details-row">
          <div class="price-details-title">
            <b>{{ $t('sales.invoices.labels.finalPrice') }}</b>
          </div>

          <div class="price-details-price">
            <span>{{ addComma(parseInt(invoice.finalPrice.value)) || 0 }}</span>
            <span>{{ $t('currency') }}</span>
          </div>
        </div>
      </div>
    </div>

    <!-- insert new sale addon prompt -->
    <vs-prompt
      class="prompt p-0"
      :buttons-hidden="true"
      title=""
      :active.sync="selectSaleAddonPromptStatus"
      @close="selectSaleAddonPromptStatus = true">

      <div class="prompt-header p-3 w-full" :class="[!this.$vs.rtl ? 'rtl-only' : '']">
        <vs-row>
          <vs-col class="w-1/5 useral-font-weight-medium text-success cursor-pointer">
            <div @click="handleClick('insertInvoiceSaleAddonsBTN')">
              <custom-icon icon="CHECK" color="success"/>
            </div>
          </vs-col>

          <vs-spacer/>

          <vs-col class="w-1/2 text-center useral-font-weight-bold text-md">
            {{ $t('sales.addons.list.title') }}
          </vs-col>

          <vs-spacer/>

          <vs-col class="w-1/5 text-right useral-font-weight-medium text-danger cursor-pointer">
            <div @click="selectSaleAddonPromptStatus = false">
              <custom-icon icon="TIMES-CIRCLE" color="danger"/>
            </div>
          </vs-col>
        </vs-row>
      </div>

      <div class="prompt-content">
        <template>
          <keep-alive>
            <select-sale-addons :user-id="invoice.user.id" @inserted="handleNewSaleAddonInserted($event)"/>
          </keep-alive>
        </template>
      </div>

    </vs-prompt>

    <!-- receive from customer -->
    <vs-prompt
      color="danger"
      :buttons-hidden="true"
      title=""
      :active.sync="receiveFromCustomerPromptStatus">

      <div class="prompt-header p-3 w-full" :class="[!this.$vs.rtl ? 'rtl-only' : '']">
        <vs-row>
          <!--          <vs-col class="w-1/5 useral-font-weight-medium text-success cursor-pointer">
                      <div>
                        <custom-icon icon="CHECK" color="success"/>
                      </div>
                    </vs-col>-->

          <vs-spacer/>

          <vs-col class="w-1/2 text-center useral-font-weight-bold text-md">
            {{ $t('treasury.receive.insert.dynamicTitle', {name: invoice.user.name.value}) }}
          </vs-col>

          <vs-spacer/>

          <!--          <vs-col class="w-1/5 text-right useral-font-weight-medium text-danger cursor-pointer">
                      <router-link :to="{name: 'saleInvoice', params: {id: this.$route.params.id}}">
                        <custom-icon icon="TIMES-CIRCLE" color="danger"/>
                      </router-link>
                    </vs-col>-->
        </vs-row>
      </div>

      <div class="prompt-content p-3">
        <insert-fast-receive :user="invoice.user" :price="userDebt"
                             :subject="invoice.id.value ? $t('sales.invoices.receive.dynamicTitle', {id: invoice.id.value}) : $t('sales.invoices.receive.title')"/>

        <div class="action-buttons">
          <button class="payment" @click="handleClick('fastReceiveBTN')">{{ $t('sales.invoices.receive.labels.payment')
            }}
          </button>

          <button @click="receiveFromCustomerPromptStatus = false" class="cancel">{{
            $t('sales.invoices.receive.labels.cancel') }}
          </button>
        </div>
      </div>
    </vs-prompt>

    <!-- select cancel type -->
    <vs-prompt
      color="danger"
      :buttons-hidden="true"
      title=""
      :active.sync="showCancelTypePromptStatus">

      <div class="prompt-header p-3 w-full" :class="[!this.$vs.rtl ? 'rtl-only' : '']">
        <vs-row>
          <!--          <vs-col class="w-1/5 useral-font-weight-medium text-success cursor-pointer">
                      <div>
                        <custom-icon icon="CHECK" color="success"/>
                      </div>
                    </vs-col>-->

          <vs-spacer/>

          <vs-col class="w-1/2 text-center useral-font-weight-bold text-md">
            {{ $t('sales.invoices.invoice.cancel.title') }}
          </vs-col>

          <vs-spacer/>

          <!--          <vs-col class="w-1/5 text-right useral-font-weight-medium text-danger cursor-pointer">
                      <router-link :to="{name: 'saleInvoice', params: {id: this.$route.params.id}}">
                        <custom-icon icon="TIMES-CIRCLE" color="danger"/>
                      </router-link>
                    </vs-col>-->
        </vs-row>
      </div>

      <div class="prompt-content p-3">
        <div class="action-buttons">
          <button class="payment" @click="invoice.cancelType = 1, $refs.returnSaleInvoiceConfirmation.showDialog()">
            {{ $t('sales.invoices.invoice.cancel.byCustomer') }}
          </button>

          <button @click="invoice.cancelType = 2, $refs.returnSaleInvoiceConfirmation.showDialog()" class="cancel">
            {{ $t('sales.invoices.invoice.cancel.bySystem') }}
          </button>
        </div>
      </div>
    </vs-prompt>

    <vs-button id="returnSaleInvoiceBTN"
               class="w-full mt-3"
               color="danger"
               v-show="false"
               @click="$refs.returnSaleInvoiceConfirmation.showDialog()">
      {{ $t('sales.invoices.invoice.labels.cancelReserve') }}
    </vs-button>

    <custom-dialog ref="returnSaleInvoiceConfirmation"
                   :title="$t('sales.invoices.invoice.confirmations.cancelReserve.title')"
                   :body="$t('sales.invoices.invoice.confirmations.cancelReserve.body')"
                   @accept="handleReturnSaleInvoice">
      <show-refund-rules :invoice-id="parseInt($route.params.id)" :cancel-type="invoice.cancelType"/>
    </custom-dialog>


    <vs-button id="returnRowSaleInvoiceBTN"
               class="w-full mt-3"
               color="danger"
               v-show="false"
               v-if="checkUserPermissions('invoice.cancel_addon')"
               @click="!selectDeletedRow.court ? $refs.returnRowSaleInvoiceConfirmation.showDialog() : handleCancelSaleAddon()">
      {{ $t('sales.invoices.invoice.labels.cancelAddon') }}
    </vs-button>

    <custom-dialog ref="returnRowSaleInvoiceConfirmation"
                   :title="$t('sales.invoices.invoice.confirmations.cancelAddon.title')"
                   :body="$t('sales.invoices.invoice.confirmations.cancelAddon.body')"
                   @accept="handleCancelSaleAddon"/>

    <button id="sendMessageSaleInvoiceBTN"
            class="w-full mt-3"
            v-show="false"
            @click="$refs.sendMessageSaleInvoiceConfirmation.showDialog()">
    </button>

    <custom-dialog ref="sendMessageSaleInvoiceConfirmation"
                   :title="$t('sales.invoices.invoice.confirmations.sendMessage.title')"
                   :body="$t('sales.invoices.invoice.confirmations.sendMessage.body')"
                   @accept="handleSendMessageInvoice"/>


    <button v-show="false" id="receiveFromCustomer" @click="completeSaleInvoice"/>
    <!-- /receive from customer -->

    <button id="insertSaleAddon" v-show="false" @click="selectSaleAddonPromptStatus = true"/>
    <button id="insertReturnSaleInvoiceBTN" v-show="false" @click="handleClick('returnSaleInvoiceBTN')"/>
  </vx-card>
</template>

<script>
  import CustomValidateInput from '@/components/customInput/customValidateInput'
  import SuggestBox from '@/components/draggableDynamicTable/suggestBox'
  import CustomNumberInput from '@/components/customInput/customNumberInput'
  import {
    completeSaleInvoice,
    getSaleInvoice,
    cancelSaleInvoice,
    cancelSaleAddon,
    deleteSaleInvoice, insertSaleInvoiceAddon, sendMessageSaleInvoice
  } from '../../../../../http/requests/sales'
  import InsertFastReceive from '../../../treasury/receive/insert/insertFastReceive'
  import axios from 'axios'
  import CustomDialog from "../../../../../components/customDialog/customDialog";
  import {addComma, checkUserPermissions, getAvatarUrl, getStaticFileUrl} from "../../../../../assets/js/functions";
  import LazyImage from "../../../../../components/lazyImage/lazyImage";
  import ImagePreview from "../../../../../components/imagePreview/imagePreview";
  import CustomIcon from "../../../../../components/customIcon/customIcon";
  import SelectSaleAddons from "./selectSaleAddons";
  import CustomPriceInput from "../../../../../components/customInput/customPriceInput";
  import ShowRefundRules from "./showRefundRules";

  export default {
    name: 'saleInvoice',
    metaInfo() {
      return {
        title: this.invoice.type && this.invoice.id.value ? this.$t('sales.invoices.invoice.dynamicTitleWithId', {
          type: this.invoice.type,
          id: this.invoice.id.value
        }) : this.$t('sales.invoices.invoice.title')
      }
    },
    components: {
      ShowRefundRules,
      CustomPriceInput,
      SelectSaleAddons,
      CustomIcon,
      ImagePreview,
      LazyImage,
      CustomDialog,
      InsertFastReceive,
      CustomNumberInput,
      SuggestBox,
      CustomValidateInput,
    },
    data() {
      return {
        imageUserPreviewStatus: false,
        imageCoachPreviewStatus: false,
        imageReservePreviewStatus: false,
        receiveFromCustomerPromptStatus: false,
        showCancelTypePromptStatus: false,
        selectSaleAddonPromptStatus: false,
        userDebt: 0,
        selectDeletedRow: {},
        options: {
          rowKeyField: 'id'
        },
        columnsLabel: [
          {
            field: 'finalPrice',
            i18n: 'sales.invoices.invoice.table.header.finalPrice',
            width: '110px',
            minWidth: 110,
            type: 'relation',
            relation: '(quantity)[*](unitPrice)',
            relationType: 'price',
          },
          {
            field: 'unitPrice',
            i18n: 'sales.invoices.invoice.table.header.unitPrice',
            width: '110px',
            minWidth: 110,
          },
          {
            field: 'quantity',
            i18n: 'sales.invoices.invoice.table.header.quantity',
            align: 'center',
            width: '50px',
            minWidth: 50,
          },
          {
            field: 'name',
            i18n: 'sales.invoices.invoice.table.header.name',
            align: 'center',
            width: 'calc(100%)',
            minWidth: 150,
          },
          {
            field: 'rowNumber',
            i18n: 'sales.invoices.invoice.table.header.row',
            align: 'center',
            width: '50px',
            minWidth: 50,
            autoIncrement: true,
          }
        ],
        invoice: {
          actionType: {
            value: '',
            isValid: true
          },
          cancelType: 1,
          id: {
            value: '',
            isValid: true
          },
          status: {
            value: '',
            isValid: true
          },
          passed: true,
          user: {
            id: 0,
            name: {
              value: '',
              isValid: true
            },
            avatar: '',
            gender: '',
            phoneNumber: ''
          },
          coach: {
            id: 0,
            name: {
              value: '',
              isValid: true
            },
            avatar: '',
            gender: '',
            phoneNumber: '',
            price: 0
          },
          reserveInfo: {
            avatar: '',
            courtName: '',
            time: '',
            date: '',
            price: ''
          },
          address: {
            value: '',
            isValid: true
          },
          date: {
            value: '',
            isValid: true
          },
          type: '',
          discount: {
            value: '0',
            isValid: true
          },
          cancelPrice: {
            value: '0',
            isValid: true
          },
          totalPrice: {
            value: '0',
            isValid: true
          },
          finalPrice: {
            value: '0',
            isValid: true
          },
          lines: [],
          selectedSaleAddon: []
        },
        invoiceProcesses: [
          {
            label: this.$t('sales.invoices.statusTypes.active'),
            value: 1
          },
          {
            label: this.$t('sales.invoices.statusTypes.canceled'),
            value: 2
          },
          {
            label: this.$t('sales.invoices.statusTypes.activePassed'),
            value: 3
          },
          {
            label: this.$t('sales.invoices.statusTypes.canceledBySystem'),
            value: 4
          },
        ],
        invoiceType: [
          {
            label: this.$t('sales.invoices.actionTypes.present'),
            value: 1
          },
          {
            label: this.$t('sales.invoices.actionTypes.tel'),
            value: 2
          },
          {
            label: this.$t('sales.invoices.actionTypes.internet'),
            value: 3
          }
        ],
        actions: [
          {
            toolbar: [
              {
                id: {name: 'editSaleInvoice'},
                type: 'link',
                icon: 'EDIT',
                iconPack: 'useral',
                color: 'warning',
                permission: 'invoice.update'
              },
              {
                id: 'sendMessageSaleInvoiceBTN',
                icon: 'SEND',
                iconPack: 'useral'
              },
            ],
            leftToolbar: [
              // {
              //   id: {name: 'print-sale-invoice-page', params: {id: this.$route.params.id}},
              //   type: 'new-page-link',
              //   icon: 'PRINT',
              //   iconPack: 'useral'
              // },
              {
                id: {name: 'saleInvoices'},
                type: 'link',
                icon: 'CHEVRON_LEFT',
                iconPack: 'useral'
              }
            ]
          }
        ]
      }
    },
    computed: {
      getAsiderUserProfileInfo() {
        const info = [
          {
            label: this.$t('sales.invoices.labels.fullName'),
            content: this.invoice.user.name.value
          },
          {
            label: this.$t('sales.invoices.labels.phoneNumber'),
            content: this.invoice.user.phoneNumber
          },
          {
            label: this.$t('sales.invoices.labels.gender'),
            content: this.invoice.user.gender === 1 ? this.$t('genderTypes.man') : this.invoice.user.gender === 2 ? this.$t('genderTypes.woman') : ''
          }
        ]
        return info
      },
      getAsiderCoachProfileInfo() {
        const info = [
          {
            label: this.$t('sales.invoices.labels.fullName'),
            content: this.invoice.coach.name.value
          },
          {
            label: this.$t('sales.invoices.labels.phoneNumber'),
            content: this.invoice.coach.phoneNumber
          },
          {
            label: `${this.$t('sales.invoices.labels.coachPrice')}: `,
            content: `${addComma(this.invoice.coach.price)} ${this.$t('currency')}`
          }
        ]
        return info
      }
    },
    created() {
      if (this.$route.name === 'saleInvoiceTrash') {
        this.actions[0].leftToolbar.splice(1, 1)
        this.actions[0].leftToolbar[1].id = {name: 'saleInvoicesTrash'}
      }

      setTimeout(() => {
        this.$store.dispatch('auth/setAccessToken')
        this.$store.dispatch('updateNavbarActions', this.actions[0])
        this.$store.dispatch('updateContentNavbarStyle', 'sticky')
        this.$store.dispatch('updateContentNavbarClass', ' md-max-w-half mx-auto')
      }, 50)

      this.getSaleInvoice()
    },
    methods: {
      checkUserPermissions(permission) {
        return checkUserPermissions(permission)
      },
      getSaleInvoice() {
        getSaleInvoice({id: this.$route.params.id}).then(response => {
          const invoice = response.data.data

          const tableRow = []
          tableRow.push({
            id: 0,
            rowNumber: 1,
            name: `${invoice.reserved_time.court.name} - ${invoice.reserved_time.time.start_time.substr(0, 5)} تا ${invoice.reserved_time.time.end_time.substr(0, 5)} - ${invoice.reserved_time.date.split(' ')[0]}`,
            quantity: 1,
            unitPrice: {value: invoice.court_price, type: 'price'},
            finalPrice: {value: '', type: 'price'},
            discount: {value: invoice.discount, type: 'price'},
            court: true
          })
          let price = invoice.court_price
          if (invoice.addons.length > 0) {
            invoice.addons.forEach(addon => {
              tableRow.push({
                id: addon.id,
                rowNumber: tableRow.length + 1,
                name: {
                  value: addon.name,
                  preContent: {
                    value: addon.required ? this.$t('sales.invoices.labels.required') : '',
                    class: 'text-danger'
                  }
                },
                required: addon.required,
                quantity: addon.quantity,
                unitPrice: {value: addon.price, type: 'price'},
                finalPrice: {value: '', type: 'price'}
              })
              price += addon.price * addon.quantity
            })
          }
          price += invoice.coach ? (invoice.coach.price - invoice.coach.discount) : 0
          this.invoice.totalPrice = {
            value: invoice.total_price + invoice.discount,
            isValid: true
          }
          this.invoice.cancelPrice = {
            value: invoice.cancel_price,
            isValid: true
          }
          this.invoice.finalPrice.value = invoice.total_price
          this.invoice.lines = tableRow
          // const row_index = this.columnsLabel.map((e) => {
          //   return e.field
          // }).indexOf('rowNumber')
          // this.columnsLabel[row_index].footer.value = this.invoice.lines.length

          this.invoice.discount.value = invoice.discount.toString()
          this.invoice.id = {value: invoice.invoice_number || invoice.id, isValid: true}
          this.invoice.date = {value: invoice.invoice_date, isValid: true}
          this.invoice.user = {
            id: invoice.user.id,
            name: {
              value: `${invoice.user.name} ${invoice.user.family}`,
              isValid: true
            },
            avatar: invoice.user.avatar ? getAvatarUrl(invoice.user.avatar) : invoice.user.gender === 1 ? getStaticFileUrl('/images/man-avatar.png') : getStaticFileUrl('/images/woman-avatar.png'),
            gender: invoice.user.gender,
            phoneNumber: invoice.user.phone_number
          }
          this.invoice.coach = {
            id: invoice.coach ? invoice.coach.id : 0,
            name: {
              value: invoice.coach ? `${invoice.coach.name} ${invoice.coach.family}` : '',
              isValid: true
            },
            avatar: invoice.coach && invoice.coach.avatar ? getAvatarUrl(invoice.coach.avatar) : getStaticFileUrl('/images/man-avatar.png'),
            phoneNumber: invoice.coach ? invoice.coach.phone_number : '',
            price: invoice.coach ? invoice.coach.price : 0
          }
          this.invoice.reserveInfo = {
            avatar: invoice.reserved_time.court.avatar ? getAvatarUrl(invoice.reserved_time.court.avatar) : require('@/assets/images/unnamed.png'),
            courtName: invoice.reserved_time.court.name || '',
            time: `${invoice.reserved_time.time.start_time.substr(0, 5)} ${this.$t('sales.invoices.labels.until')} ${invoice.reserved_time.time.end_time.substr(0, 5)}`,
            date: invoice.reserved_time.date.split(' ')[0],
            price: invoice.court_price
          }
          let status = ''
          if (invoice.status === 1) {
            if (invoice.passed) {
              status = this.invoiceProcesses[2]
            } else {
              status = this.invoiceProcesses[0]
            }
          } else if (invoice.status === 2) {
            status = invoice.cancel_type === 1 ? this.invoiceProcesses[2] : this.invoiceProcesses[3]
          }

          this.invoice.status = {id: invoice.status, value: status.label, isValid: true}
          this.invoice.actionType = {
            id: invoice.action_type,
            value: this.getInvoiceActionType(invoice.action_type),
            isValid: true
          }

          if (invoice.address) {
            this.invoice.address = {
              value: `${invoice.address.province}, ${invoice.address.city}, ${invoice.address.address}`,
              isValid: true
            }
          }

          switch (invoice.action_type) {
            case 1:
              this.invoice.type = this.$t('sales.invoices.actionTypes.shortPresent')
              break

            case 2:
              this.invoice.type = this.$t('sales.invoices.actionTypes.shortTel')
              break

            case 3:
              this.invoice.type = this.$t('sales.invoices.actionTypes.shortInternet')
              break
          }

          const actions = JSON.parse(JSON.stringify(this.actions[0]))
          const editSaleAddonIndex = actions.toolbar.map(e => e.id).indexOf('editSaleInvoice')
          if (invoice.status === 2 && editSaleAddonIndex > -1) {
            actions.toolbar.splice(editSaleAddonIndex, 1)
          }
          if (invoice.passed) {
            const trashIndex = actions.leftToolbar.map(e => e.icon).indexOf('TRASH')
            if (trashIndex > -1) {
              actions.leftToolbar.splice(trashIndex, 1)
            }
          }
          if (invoice.status === 1 && !invoice.passed && this.$route.name === 'saleInvoice') {
            actions.toolbar.push({
              id: invoice.status === 3 ? {
                name: 'insertReturnSaleInvoice',
                params: {id: this.$route.params.id}
              } : 'insertReturnSaleInvoiceBTN',
              type: invoice.status === 3 ? 'link' : null,
              icon: 'RETURN_SALE',
              iconPack: 'useral',
              color: 'danger',
              style: 'margin-right: 5px;',
              permission: 'invoice.cancel'
            })
          } else {
            const delete_index = this.columnsLabel.map(e => e.field).indexOf('delete')
            if (delete_index > -1) {
              this.columnsLabel.splice(delete_index, 1)
            }
          }

          const delete_index = this.columnsLabel.map(e => e.field).indexOf('delete')
          if (delete_index > -1 && (invoice.status === 2 || !checkUserPermissions('invoice.cancel_addon'))) {
            this.columnsLabel.splice(delete_index, 1)
          }
          // actions.leftToolbar[1].id.name = 'returnSaleInvoices'

          setTimeout(() => {
            this.$store.dispatch('updateNavbarActions', actions)
          }, 50)

          this.$store.dispatch('setPageTitle', this.$t('sales.invoices.invoice.dynamicTitle', {type: this.invoice.type}))
        })
      },
      getInvoiceStatus(id) {
        return this.invoiceProcesses[id - 1].label
      },
      getInvoiceActionType(id) {
        return this.invoiceType[id - 1].label
      },
      completeSaleInvoice() {
        completeSaleInvoice(this.$route.params.id).then(() => {
          this.$vs.notify({
            title: this.$t('alert.message.title'),
            text: this.$t('sales.invoices.notifications.complete.success'),
            color: 'success',
            icon: 'icon-check',
            iconPack: 'feather',
            time: 2400
          })
          this.receiveFromCustomerPromptStatus = false

          setTimeout(() => {
            this.$store.dispatch('updateNavbarActions', this.actions[0])
          }, 50)

          // window.open(this.$router.resolve({name: 'print-sale-invoice-page', params:{id: this.$route.params.id}}).href, '_blank')
        }).catch(error => {
          if (axios.isCancel(error)) {
            this.$vs.notify({
              title: this.$t('alert.duplicateRequest.title'),
              text: this.$t('alert.duplicateRequest.message'),
              icon: 'icon-alert-circle',
              iconPack: 'feather',
              time: 2400,
              color: 'warning'
            })
          } else {
            const error_mapper = {
              'name': ''
            }
            switch (error.response.status) {
              case 409:
                if (error.response.data && error.response.data.data && error.response.data.data.hasOwnProperty('user_debt')) {
                  const newInvoice = error.response.data.data

                  this.$vs.notify({
                    title: this.$t('alert.error.title'),
                    text: this.$t('sales.invoices.notifications.lowMoney'),
                    color: 'warning',
                    icon: 'icon-alert-circle',
                    iconPack: 'feather',
                    time: 2400
                  })

                  this.userDebt = Math.abs(newInvoice.user_debt)
                  this.receiveFromCustomerPromptStatus = true

                } else {
                  this.$vs.notify({
                    title: this.$t('alert.error.title'),
                    text: this.$t('sales.invoices.notifications.noTimeExist'),
                    color: 'danger',
                    icon: 'icon-alert-circle',
                    iconPack: 'feather',
                    time: 2400
                  })
                }
                break

              case 422:
                Object.keys(error.response.data.errors).forEach((error_key) => {
                  const err = error_key.toString().split('.')
                  if (error_mapper[err[err.length - 1]]) {
                    this.$vs.notify({
                      title: this.$t('alert.error.title'),
                      text: error_mapper[err[err.length - 1]],
                      color: 'danger',
                      icon: 'icon-alert-circle',
                      iconPack: 'feather',
                      time: 2400
                    })
                    error_mapper[err[err.length - 1]] = null
                  }
                })
                break

              default:
                this.$vs.notify({
                  title: this.$t('alert.error.title'),
                  text: this.$t('sales.invoices.notifications.complete.error'),
                  color: 'danger',
                  icon: 'icon-alert-circle',
                  iconPack: 'feather',
                  time: 2400
                })
                break
            }
          }
        })
      },
      handleClick(id) {
        document.getElementById(id).click()
      },
      addComma(val) {
        let sign = ''

        if (val < 0) sign = '-'

        val = val.toString()

        if (val[0] === '0') val = val.substr(1, val.length - 1)

        return val.toString().replace(/\D/g, '')
          .replace(/\B(?=(\d{3})+(?!\d))/g, ',') + sign
      },
      handleReturnSaleInvoice() {
        const payload = {
          cancel_type: this.invoice.cancelType
        }
        cancelSaleInvoice(this.$route.params.id, payload).then(response => {
          this.$vs.notify({
            title: this.$t('alert.message.title'),
            text: this.$t('sales.invoices.notifications.cancel.success'),
            color: 'success',
            icon: 'icon-check',
            iconPack: 'feather',
            time: 2400
          })
          this.showCancelTypePromptStatus = false
          this.$router.replace({name: 'saleInvoices'})
        })
          .catch(error => {
            if (axios.isCancel(error)) {
              this.$vs.notify({
                title: this.$t('alert.duplicateRequest.title'),
                text: this.$t('alert.duplicateRequest.message'),
                icon: 'icon-alert-circle',
                iconPack: 'feather',
                time: 2400,
                color: 'warning'
              })
            } else {
              switch (error.response.status) {
                case 409:
                  this.$vs.notify({
                    title: this.$t('alert.error.title'),
                    text: this.$t('sales.invoices.notifications.timesCanceled'),
                    color: 'danger',
                    icon: 'icon-alert-circle',
                    iconPack: 'feather',
                    time: 2400
                  })
                  break
                default:
                  this.$vs.notify({
                    title: this.$t('alert.error.title'),
                    text: this.$t('sales.invoices.notifications.cancel.error'),
                    time: 2400,
                    color: 'danger',
                    icon: 'icon-alert-circle',
                    iconPack: 'feather'
                  })
                  break
              }
            }
          })
      },
      handleCancelSaleAddon() {
        const row = this.selectDeletedRow
        if (!row.court) {
          if (!row.required) {
            const payload = {
              cancel_type: 1
            }
            cancelSaleAddon(this.$route.params.id, row.id, payload).then(() => {
              this.$vs.notify({
                title: this.$t('alert.message.title'),
                text: this.$t('sales.invoices.notifications.cancelSaleAddon.success'),
                color: 'success',
                icon: 'icon-check',
                iconPack: 'feather',
                time: 2400
              })
              this.getSaleInvoice()
            })
              .catch(error => {
                if (axios.isCancel(error)) {
                  this.$vs.notify({
                    title: this.$t('alert.duplicateRequest.title'),
                    text: this.$t('alert.duplicateRequest.message'),
                    icon: 'icon-alert-circle',
                    iconPack: 'feather',
                    time: 2400,
                    color: 'warning'
                  })
                } else {
                  switch (error.response.status) {
                    case 409:
                      this.$vs.notify({
                        title: this.$t('alert.error.title'),
                        text: this.$t('sales.invoices.notifications.addonCanceled'),
                        color: 'danger',
                        icon: 'icon-alert-circle',
                        iconPack: 'feather',
                        time: 2400
                      })
                      break
                    default:
                      this.$vs.notify({
                        title: this.$t('alert.error.title'),
                        text: this.$t('sales.invoices.notifications.cancelSaleAddon.error'),
                        time: 2400,
                        color: 'danger',
                        icon: 'icon-alert-circle',
                        iconPack: 'feather'
                      })
                      break
                  }

                }
              })
          } else {
            this.$vs.notify({
              title: this.$t('alert.error.title'),
              text: this.$t('sales.invoices.notifications.cantDeleteAddon'),
              color: 'danger',
              icon: 'icon-alert-circle',
              iconPack: 'feather',
              time: 2400
            })
          }
        } else {
          this.$vs.notify({
            title: this.$t('alert.error.title'),
            text: this.$t('sales.invoices.notifications.cantDeleteCourt'),
            color: 'danger',
            icon: 'icon-alert-circle',
            iconPack: 'feather',
            time: 2400
          })
        }

      },

      handleNewSaleAddonInserted(list) {
        if (list && list.length > 0) {
          this.selectedSaleAddon = []
          list.forEach(item => {
            const addonId = this.invoice.lines.map(e => e.id).indexOf(item.id)
            if (addonId === -1) {
              this.selectedSaleAddon.push({
                sale_addon_id: item.id,
                quantity: item.quantity
              })
            } else {
              this.$vs.notify({
                title: this.$t('alert.error.title'),
                text: this.$t('sales.invoices.notifications.addonExist', {name: item.name}),
                color: 'danger',
                icon: 'icon-alert-circle',
                iconPack: 'feather',
                time: 4000
              })
            }
          })
        }
        if (this.selectedSaleAddon.length > 0 && checkUserPermissions('invoice.add_addon')) {
          const payload = {addons: this.selectedSaleAddon}
          insertSaleInvoiceAddon(this.$route.params.id, payload).then(() => {
            this.$vs.notify({
              title: this.$t('alert.message.title'),
              text: this.$t('sales.invoices.notifications.insertAddon.success'),
              color: 'success',
              icon: 'icon-check',
              iconPack: 'feather',
              time: 2400
            })
            this.selectSaleAddonPromptStatus = false
            this.getSaleInvoice()
          })
            .catch(error => {
              if (axios.isCancel(error)) {
                this.$vs.notify({
                  title: this.$t('alert.duplicateRequest.title'),
                  text: this.$t('alert.duplicateRequest.message'),
                  icon: 'icon-alert-circle',
                  iconPack: 'feather',
                  time: 2400,
                  color: 'warning'
                })
              } else {
                switch (error.response.status) {
                  case 409:
                    // if (error.response.data && error.response.data.data && error.response.data.data.hasOwnProperty('user_debt')) {
                    const invoice = error.response.data

                    if (invoice.error_type === 'balance_error') {
                      this.$vs.notify({
                        title: this.$t('alert.error.title'),
                        text: this.$t('sales.invoices.notifications.lowMoneyForAddon'),
                        color: 'danger',
                        icon: 'icon-alert-circle',
                        iconPack: 'feather',
                        time: 2400
                      })

                      this.userDebt = Math.abs(invoice.money_deficit)
                      this.invoice.id.value = invoice.id
                      this.receiveFromCustomerPromptStatus = true
                    } else {
                      this.$vs.notify({
                        title: this.$t('alert.error.title'),
                        text: this.$t('sales.invoices.notifications.timesReserved'),
                        color: 'danger',
                        icon: 'icon-alert-circle',
                        iconPack: 'feather',
                        time: 2400
                      })
                    }
                    break

                  default:
                    this.$vs.notify({
                      title: this.$t('alert.error.title'),
                      text: this.$t('sales.invoices.notifications.insertAddon.error'),
                      color: 'danger',
                      icon: 'icon-alert-circle',
                      iconPack: 'feather',
                      time: 2400
                    })
                    break
                }
              }
              this.selectSaleAddonPromptStatus = false
            })
        }
      },
      handleOpenSelectSaleAddonPrompt(index) {
        this.selectSaleAddonPromptStatus = true
        this.selectedIndex = index
      },
      handleSendMessageInvoice() {
        sendMessageSaleInvoice(this.$route.params.id).then(() => {
          this.$vs.notify({
            title: this.$t('alert.message.title'),
            text: this.$t('sales.invoices.notifications.sendMessage.success'),
            color: 'success',
            icon: 'icon-check',
            iconPack: 'feather',
            time: 2400
          })
        })
          .catch(error => {
            if (axios.isCancel(error)) {
              this.$vs.notify({
                title: this.$t('alert.duplicateRequest.title'),
                text: this.$t('alert.duplicateRequest.message'),
                icon: 'icon-alert-circle',
                iconPack: 'feather',
                time: 2400,
                color: 'warning'
              })
            } else {
              this.$vs.notify({
                title: this.$t('alert.error.title'),
                text: this.$t('sales.invoices.notifications.sendMessage.error'),
                time: 2400,
                color: 'danger',
                icon: 'icon-alert-circle',
                iconPack: 'feather'
              })
            }
          })
      }
    },
    watch: {
      '$store.state.helper.documentsChanged': {
        handler(val) {
          if (val) {
            this.receiveFromCustomerPromptStatus = false
            this.handleNewSaleAddonInserted()
          }
        },
        deep: true
      }
    }
  }
</script>

<style lang="scss">
  @import "../../../../../assets/scss/vuexy/variables";

  .sale-invoice {
    width: 50%;
    min-width: 700px;

    @media screen and (max-width: 800px) {
      min-width: unset;
      width: 100%;
    }

    .vx-card__body {
      padding: 0 !important;
      display: flex;
      flex-direction: column;

      .general-fields, .products-fields, .owner-info, .coach-info {
        padding: .5rem;
      }

      .process-timeline {
        background: #cecece22;
      }

      .general-fields {
        background: #cecece22;
        border-bottom: 1px solid #cecece;
        padding-bottom: 0;

        .custom-validate-input label {
          background-color: #ffffff;
        }

        .custom-validate-input.danger {
          label {
            background-color: #fad8d8;

            .input-label {
              background: linear-gradient(180deg, #f8f8f8, #fad8d8);
            }
          }
        }

        .custom-validate-input label span.is-focus,
        .custom-number-input label span.is-focus {
          backdrop-filter: sepia(1);
          background: linear-gradient(180deg, #f8f8f8, #ffffff);
        }
      }

      .products-fields {
        flex-grow: 1;
        height: calc(100vh - 516px) !important;
        min-height: 215px;
        display: flex;
        flex-direction: column;

        .draggable-dynamic-table {

          .new-suggest-modal-button {
            display: none;
          }

          .suggest-modal-button {
            right: 7px !important;
          }
        }
      }

      .price-box {
        padding: 0 0.5rem 0.5rem;
      }

      .price-details {
        display: block;
        border: 1px solid #cecece;
        border-radius: .5rem;
        width: 220px;
        margin-left: auto;
        text-align: center;
        line-height: 40px;

        .price-details-row {
          display: flex;
          border-bottom: 1px solid #cecece;

          &:last-child {
            border: none;
          }

          .price-details-title {
            width: 50%;
            border-right: 1px solid #cecece;
            background: #cecece50;
          }

          .price-details-price {
            display: flex;
            justify-content: center;
            width: 50%;

            span:first-child {
              margin-right: 5px;
              font-weight: bold;
            }

            span:last-child {

            }
          }
        }
      }

      .owner-info, .coach-info {
        position: relative;
        margin: 15px 0.5rem 0;
        height: calc(100% - 15px);
        border: 1px solid #cdcdcd;
        border-radius: 0.5rem;
        display: flex;

        .title {
          font-size: 14px;
          font-weight: bold;
          position: absolute;
          top: -12px;
          left: 10px;
          padding: 0 5px;
          background-color: #ffffff;
        }

        .user-image {
          max-width: 50px;
          max-height: 50px;
          border-radius: 0.5rem;
          overflow: hidden;
          display: flex;
          align-items: center;

          .profile-avatar {
            width: 100%;
            object-fit: cover;
          }
        }

        .user-info {
          padding: 0 0.5rem;
          width: 100%;
          display: flex;
          align-items: center;
          justify-content: space-between;

          .user-info-item {
            line-height: 32px;

            .pre-content {
              font-size: 12px;
              color: #888888;
            }

            .content {
              font-weight: bold;
            }
          }
        }

      }
    }

    .select-user-invoice {
      position: relative;

      .suggest-modal-button, .new-suggest-modal-button {
        position: absolute;
        bottom: 0;
        right: 42px;
        top: 20px;
        width: 25px;
        height: 25px;
        padding: 5px;
        border: 1px solid #00bcd4;
        border-radius: .5rem;
        color: #00bcd4;
        background: white;
        cursor: pointer;
      }

      .new-suggest-modal-button {
        right: 12px;
        border: 1px solid #28C76F;
        color: #28C76F;
      }

      .suggest-box {

        ul {
          margin-top: -10px;
          border-radius: .5rem;
          padding: 0 10px;
          line-height: 35px;
          background: white;
          box-shadow: 0 5px 10px -8px;
          border: 1px solid #cecece;
          /*right: .5rem;
          left: .5rem;*/

          &::-webkit-scrollbar {
            display: none;
          }

          li {
            cursor: pointer;
            border-top: 1px solid #cecece;

            &:first-child {
              border-top: none !important;
            }
          }
        }
      }
    }

    table {
      border: 1px solid #1b1b1c;
      border-radius: 5px;

      tr {

        div.select-suggest-list {
          right: 0 !important;
          left: 0 !important;
        }
      }
    }
  }

  .action-buttons {
    display: flex;

    button {
      flex: 1;
      line-height: 40px;
      border-radius: .5rem;
      border: none;
      color: #ffffff;
      transition: all .3s ease;
      cursor: pointer;

      &.payment {
        margin-right: 10px;
        background: #33b000cf;

        &:hover {
          background: #33b000;
        }
      }

      &.cancel {
        background: #b00000af;

        &:hover {
          background: #b00000;
        }
      }
    }
  }
</style>
